export const PATCH_CLIENT_CASE = 'PATCH_CLIENT_CASE';
export const PATCH_CLIENT_CASE_SUCCESS = 'PATCH_CLIENT_CASE_SUCCESS';
export const PATCH_CLIENT_CASE_FAIL = 'PATCH_CLIENT_CASE_FAIL';

export const GET_CLIENT_CASE_DATA = 'GET_CLIENT_CASE_DATA';
export const GET_CLIENT_CASE_DATA_SUCCESS = 'GET_CLIENT_CASE_DATA_SUCCESS';
export const GET_CLIENT_CASE_DATA_FAIL = 'GET_CLIENT_CASE_DATA_FAIL';
